import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-seperate-form',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, LoaderComponent,],
  templateUrl: './seperate-form.component.html',
  styleUrl: './seperate-form.component.scss'
})
export class SeperateFormComponent {
  isDisabled:boolean=false;

  Filter = {
    EmpName : null
  }
  constructor(
      private session:SessionService,
      private toast: ToastService,
      private router: Router,
      private route: ActivatedRoute
    ){
      //this.route.params.subscribe(params => this.FeedDetails.ESS_PostMasterID = parseInt(params['id']));
      console.log(this.session.GetUserDetails());
    }
  
    ngOnInit(){
      
    }

    Validate(form: any) {
      if (form.valid) {

      }
      else {
        form.submitted = true;
      }
    }
}
